import CANCELLATION_POLICIES_JSON from "../schemas/cancellation_policies";

export const CANCELLATION_POLICIES = CANCELLATION_POLICIES_JSON;

const getIdsFromNumber = (number) => {
    const binaryString = number.toString(2);
    const binaryArray = binaryString.split("");
    const binaryArrayReversed = binaryArray.reverse();
    const ids = getIds();
    const idsArray = [];
    binaryArrayReversed.forEach((bit, index) => {
        if (bit === "1") {
            idsArray.push(ids[index]);
        }
    });
    return idsArray;
};

const getIds = () => [...Object.values(CANCELLATION_POLICIES).map(policy => policy.id)];

// autogenerate on load
const cancellation_policies_copy = {}
Object.values(CANCELLATION_POLICIES).forEach(value => {
    cancellation_policies_copy[value.id] = value.xlat;
});

export const cancellation_policies = cancellation_policies_copy;

export const getTranslatedName = (payment_methods, id, lang) => {
    let language = lang.substring(0,2);
    if (language !== 'es' && language!== 'en') { language = 'en'; }
    return [cancellation_policies[id][language].name]
};

// const getTranslatedDescription = (id, language) => this.cancellation_policies[id][language].desc;

export const getTranslatedNameFromNumber = (environmental_policies, number, language) => {
    const ids = getIdsFromNumber(number);
    const names = ids.map(id => getTranslatedName(environmental_policies, id, language));
    return names;
};